import GET_CONTESTS from "./getContests"

export default {
  GET_CONTESTS
}
